export default {"src":"/_next/static/media/icon.555bae2e.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};